import { render, staticRenderFns } from "./BusinessRisk.vue?vue&type=template&id=83e2ce7c&"
import script from "./BusinessRisk.vue?vue&type=script&lang=js&"
export * from "./BusinessRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports